"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeToNewslettersPlaceEnum = exports.CustomerApi = void 0;
var runtime = __importStar(require("../runtime"));
var models_1 = require("../models");
/**
 *
 */
var CustomerApi = /** @class */ (function (_super) {
    __extends(CustomerApi, _super);
    function CustomerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerApi.prototype.buildUrl = function (path, queryParameters) {
        var query = this.configuration.queryParamsStringify(queryParameters);
        return "".concat(this.configuration.basePath).concat(path).concat(query && "?".concat(query));
    };
    CustomerApi.prototype.getInternalCallInfoForAddPhoneNumber = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/phonebook"
        };
    };
    CustomerApi.prototype.getUrlForAddPhoneNumberByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForAddPhoneNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * updates a phone number for the customer
     */
    CustomerApi.prototype.addPhoneNumberRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForAddPhoneNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.xEcFp !== undefined && requestParameters.xEcFp !== null) {
                            headerParameters['x-ec-fp'] = String(requestParameters.xEcFp);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SavePhoneNumberRequestToJSON)(requestParameters.savePhoneNumberRequest),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultWithPhoneBookFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * updates a phone number for the customer
     */
    CustomerApi.prototype.addPhoneNumber = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addPhoneNumberRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForCancelPremium = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/premium"
        };
    };
    CustomerApi.prototype.getUrlForCancelPremiumByDELETE = function (requestParameters) {
        var _a = this.getInternalCallInfoForCancelPremium(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Cancel membership of customer loyalty program
     */
    CustomerApi.prototype.cancelPremiumRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForCancelPremium(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CancelPremiumResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Cancel membership of customer loyalty program
     */
    CustomerApi.prototype.cancelPremium = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cancelPremiumRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForChangeEmailAddress = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/email"
        };
    };
    CustomerApi.prototype.getUrlForChangeEmailAddressByPUT = function (requestParameters) {
        var _a = this.getInternalCallInfoForChangeEmailAddress(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     */
    CustomerApi.prototype.changeEmailAddressRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForChangeEmailAddress(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.xEcFp !== undefined && requestParameters.xEcFp !== null) {
                            headerParameters['x-ec-fp'] = String(requestParameters.xEcFp);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ChangeEmailAddressRequestPayloadToJSON)(requestParameters.changeEmailAddressRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CustomerApi.prototype.changeEmailAddress = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeEmailAddressRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForChangePassword = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/password"
        };
    };
    CustomerApi.prototype.getUrlForChangePasswordByPUT = function (requestParameters) {
        var _a = this.getInternalCallInfoForChangePassword(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     */
    CustomerApi.prototype.changePasswordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForChangePassword(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.xEcFp !== undefined && requestParameters.xEcFp !== null) {
                            headerParameters['x-ec-fp'] = String(requestParameters.xEcFp);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ChangePasswordRequestPayloadToJSON)(requestParameters.changePasswordRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultWithTokensFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CustomerApi.prototype.changePassword = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changePasswordRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForDeleteCreditCard = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/creditcard"
        };
    };
    CustomerApi.prototype.getUrlForDeleteCreditCardByDELETE = function (requestParameters) {
        var _a = this.getInternalCallInfoForDeleteCreditCard(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * deletes the stored creditcard from the customers profile
     */
    CustomerApi.prototype.deleteCreditCardRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForDeleteCreditCard(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * deletes the stored creditcard from the customers profile
     */
    CustomerApi.prototype.deleteCreditCard = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteCreditCardRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForDeletePhoneNumber = function (requestParameters) {
        if (requestParameters.index === null || requestParameters.index === undefined) {
            throw new runtime.RequiredError('index', 'Required parameter requestParameters.index was null or undefined when calling deletePhoneNumber.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/phonebook/{index}".replace("{".concat("index", "}"), encodeURIComponent(String(requestParameters.index)))
        };
    };
    CustomerApi.prototype.getUrlForDeletePhoneNumberByDELETE = function (requestParameters) {
        var _a = this.getInternalCallInfoForDeletePhoneNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * deletes a phone number from the customer
     */
    CustomerApi.prototype.deletePhoneNumberRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForDeletePhoneNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.xEcFp !== undefined && requestParameters.xEcFp !== null) {
                            headerParameters['x-ec-fp'] = String(requestParameters.xEcFp);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultWithPhoneBookFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * deletes a phone number from the customer
     */
    CustomerApi.prototype.deletePhoneNumber = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deletePhoneNumberRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForDownloadSepaMandate = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/sepa/document.pdf"
        };
    };
    CustomerApi.prototype.getUrlForDownloadSepaMandateByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForDownloadSepaMandate(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Provide sepa mandate document (pdf) for download
     */
    CustomerApi.prototype.downloadSepaMandateRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForDownloadSepaMandate(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Provide sepa mandate document (pdf) for download
     */
    CustomerApi.prototype.downloadSepaMandate = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadSepaMandateRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForGetCustomer = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer"
        };
    };
    CustomerApi.prototype.getUrlForGetCustomerByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetCustomer(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     */
    CustomerApi.prototype.getCustomerRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetCustomer(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CustomerDataWithStatusFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CustomerApi.prototype.getCustomer = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForGetCustomerAbstract = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/abstract"
        };
    };
    CustomerApi.prototype.getUrlForGetCustomerAbstractByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetCustomerAbstract(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     */
    CustomerApi.prototype.getCustomerAbstractRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetCustomerAbstract(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AbstractCustomerDataFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CustomerApi.prototype.getCustomerAbstract = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerAbstractRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForGetCustomerCreditData = function (requestParameters) {
        var queryParameters = {};
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        return {
            queryParameters: queryParameters,
            path: "/customer/credit"
        };
    };
    CustomerApi.prototype.getUrlForGetCustomerCreditDataByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetCustomerCreditData(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     */
    CustomerApi.prototype.getCustomerCreditDataRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetCustomerCreditData(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CustomerCreditDataFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CustomerApi.prototype.getCustomerCreditData = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerCreditDataRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForGetCustomerPaylink = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/paylink"
        };
    };
    CustomerApi.prototype.getUrlForGetCustomerPaylinkByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetCustomerPaylink(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     */
    CustomerApi.prototype.getCustomerPaylinkRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetCustomerPaylink(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaylinkFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CustomerApi.prototype.getCustomerPaylink = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerPaylinkRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForGetCustomerStatus = function (requestParameters) {
        var queryParameters = {};
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        return {
            queryParameters: queryParameters,
            path: "/customer/status"
        };
    };
    CustomerApi.prototype.getUrlForGetCustomerStatusByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetCustomerStatus(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     */
    CustomerApi.prototype.getCustomerStatusRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetCustomerStatus(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CustomerStatusFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CustomerApi.prototype.getCustomerStatus = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerStatusRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForGetInformation = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/info"
        };
    };
    CustomerApi.prototype.getUrlForGetInformationByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetInformation(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Get some information about the customer
     */
    CustomerApi.prototype.getInformationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetInformation(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CustomerInformationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get some information about the customer
     */
    CustomerApi.prototype.getInformation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInformationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForGetPhoneBook = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/phonebook"
        };
    };
    CustomerApi.prototype.getUrlForGetPhoneBookByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetPhoneBook(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Get the phone book of the current user
     */
    CustomerApi.prototype.getPhoneBookRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetPhoneBook(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.PhoneNumberWithTypeFromJSON); })];
                }
            });
        });
    };
    /**
     * Get the phone book of the current user
     */
    CustomerApi.prototype.getPhoneBook = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPhoneBookRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForGetQrCodePaymentDocument = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/qrcode-payment.pdf"
        };
    };
    CustomerApi.prototype.getUrlForGetQrCodePaymentDocumentByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetQrCodePaymentDocument(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * download the qr code payment form as a pdf document
     */
    CustomerApi.prototype.getQrCodePaymentDocumentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetQrCodePaymentDocument(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * download the qr code payment form as a pdf document
     */
    CustomerApi.prototype.getQrCodePaymentDocument = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getQrCodePaymentDocumentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForGrantSepaDirectDebitAuthorisation = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/sepa"
        };
    };
    CustomerApi.prototype.getUrlForGrantSepaDirectDebitAuthorisationByPUT = function (requestParameters) {
        var _a = this.getInternalCallInfoForGrantSepaDirectDebitAuthorisation(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * grants the customers authorisation for a sepa mandate
     */
    CustomerApi.prototype.grantSepaDirectDebitAuthorisationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGrantSepaDirectDebitAuthorisation(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GrantSepaDirectDebitAuthorisationResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * grants the customers authorisation for a sepa mandate
     */
    CustomerApi.prototype.grantSepaDirectDebitAuthorisation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.grantSepaDirectDebitAuthorisationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForIdentifyCustomerByCustomerNumber = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/identify/customerNumber"
        };
    };
    CustomerApi.prototype.getUrlForIdentifyCustomerByCustomerNumberByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForIdentifyCustomerByCustomerNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Identify customer by customer number and tenant
     */
    CustomerApi.prototype.identifyCustomerByCustomerNumberRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (requestParameters.xEcClient === null || requestParameters.xEcClient === undefined) {
                            throw new runtime.RequiredError('xEcClient', 'Required parameter requestParameters.xEcClient was null or undefined when calling identifyCustomerByCustomerNumber.');
                        }
                        if (requestParameters.xEcTimestamp === null || requestParameters.xEcTimestamp === undefined) {
                            throw new runtime.RequiredError('xEcTimestamp', 'Required parameter requestParameters.xEcTimestamp was null or undefined when calling identifyCustomerByCustomerNumber.');
                        }
                        if (requestParameters.xEcHmac === null || requestParameters.xEcHmac === undefined) {
                            throw new runtime.RequiredError('xEcHmac', 'Required parameter requestParameters.xEcHmac was null or undefined when calling identifyCustomerByCustomerNumber.');
                        }
                        _a = this.getInternalCallInfoForIdentifyCustomerByCustomerNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.xEcClient !== undefined && requestParameters.xEcClient !== null) {
                            headerParameters['x-ec-client'] = String(requestParameters.xEcClient);
                        }
                        if (requestParameters.xEcTimestamp !== undefined && requestParameters.xEcTimestamp !== null) {
                            headerParameters['x-ec-timestamp'] = String(requestParameters.xEcTimestamp);
                        }
                        if (requestParameters.xEcHmac !== undefined && requestParameters.xEcHmac !== null) {
                            headerParameters['x-ec-hmac'] = String(requestParameters.xEcHmac);
                        }
                        return [4 /*yield*/, this.request({
                                path: path,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.IdentifyCustomerByCustomerNumberRequestPayloadToJSON)(requestParameters.identifyCustomerByCustomerNumberRequestPayload),
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.IdentifyCustomerByCustomerNumberResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Identify customer by customer number and tenant
     */
    CustomerApi.prototype.identifyCustomerByCustomerNumber = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.identifyCustomerByCustomerNumberRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForReclaimProduct = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/reclamation"
        };
    };
    CustomerApi.prototype.getUrlForReclaimProductByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForReclaimProduct(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Submit a reclamation for a product
     */
    CustomerApi.prototype.reclaimProductRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForReclaimProduct(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ReclaimProductRequestPayloadToJSON)(requestParameters.reclaimProductRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Submit a reclamation for a product
     */
    CustomerApi.prototype.reclaimProduct = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reclaimProductRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForReconfirmTermsAndConditionsAfterLogin = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/tac/reconfirmAfterLogin"
        };
    };
    CustomerApi.prototype.getUrlForReconfirmTermsAndConditionsAfterLoginByPUT = function (requestParameters) {
        var _a = this.getInternalCallInfoForReconfirmTermsAndConditionsAfterLogin(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Reconfirm changed terms and conditions after login
     */
    CustomerApi.prototype.reconfirmTermsAndConditionsAfterLoginRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForReconfirmTermsAndConditionsAfterLogin(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GenericSuccessResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Reconfirm changed terms and conditions after login
     */
    CustomerApi.prototype.reconfirmTermsAndConditionsAfterLogin = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reconfirmTermsAndConditionsAfterLoginRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForRegistration = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/register"
        };
    };
    CustomerApi.prototype.getUrlForRegistrationByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForRegistration(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * register and login a new customer
     */
    CustomerApi.prototype.registrationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForRegistration(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.xEcFp !== undefined && requestParameters.xEcFp !== null) {
                            headerParameters['x-ec-fp'] = String(requestParameters.xEcFp);
                        }
                        if (requestParameters.xEcTimestamp !== undefined && requestParameters.xEcTimestamp !== null) {
                            headerParameters['x-ec-timestamp'] = String(requestParameters.xEcTimestamp);
                        }
                        if (requestParameters.xEcHmac !== undefined && requestParameters.xEcHmac !== null) {
                            headerParameters['x-ec-hmac'] = String(requestParameters.xEcHmac);
                        }
                        if (requestParameters.xEcHfi !== undefined && requestParameters.xEcHfi !== null) {
                            headerParameters['x-ec-hfi'] = String(requestParameters.xEcHfi);
                        }
                        if (requestParameters.skipValidation !== undefined && requestParameters.skipValidation !== null) {
                            headerParameters['skip-validation'] = String(requestParameters.skipValidation);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.RegisterRequestPayloadToJSON)(requestParameters.registerRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RegisterResponsePayloadFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * register and login a new customer
     */
    CustomerApi.prototype.registration = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.registrationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForRevokeSepaDirectDebitAuthorisation = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/sepa"
        };
    };
    CustomerApi.prototype.getUrlForRevokeSepaDirectDebitAuthorisationByDELETE = function (requestParameters) {
        var _a = this.getInternalCallInfoForRevokeSepaDirectDebitAuthorisation(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * revokes the customers authorisation for a sepa mandate
     */
    CustomerApi.prototype.revokeSepaDirectDebitAuthorisationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForRevokeSepaDirectDebitAuthorisation(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * revokes the customers authorisation for a sepa mandate
     */
    CustomerApi.prototype.revokeSepaDirectDebitAuthorisation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.revokeSepaDirectDebitAuthorisationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForSaveIban = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/iban"
        };
    };
    CustomerApi.prototype.getUrlForSaveIbanByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForSaveIban(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * saves the given iban to the customers profile
     */
    CustomerApi.prototype.saveIbanRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (requestParameters.saveIbanRequestPayload === null || requestParameters.saveIbanRequestPayload === undefined) {
                            throw new runtime.RequiredError('saveIbanRequestPayload', 'Required parameter requestParameters.saveIbanRequestPayload was null or undefined when calling saveIban.');
                        }
                        _a = this.getInternalCallInfoForSaveIban(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.xEcFp !== undefined && requestParameters.xEcFp !== null) {
                            headerParameters['x-ec-fp'] = String(requestParameters.xEcFp);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SaveIbanRequestPayloadToJSON)(requestParameters.saveIbanRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * saves the given iban to the customers profile
     */
    CustomerApi.prototype.saveIban = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.saveIbanRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForSaveSepaBankAccount = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/sepa"
        };
    };
    CustomerApi.prototype.getUrlForSaveSepaBankAccountByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForSaveSepaBankAccount(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * saves the given bank account to the customers profile and genarates a sepa mandate to be accepted by the customer
     */
    CustomerApi.prototype.saveSepaBankAccountRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (requestParameters.saveSepaBankAccountRequestPayload === null || requestParameters.saveSepaBankAccountRequestPayload === undefined) {
                            throw new runtime.RequiredError('saveSepaBankAccountRequestPayload', 'Required parameter requestParameters.saveSepaBankAccountRequestPayload was null or undefined when calling saveSepaBankAccount.');
                        }
                        _a = this.getInternalCallInfoForSaveSepaBankAccount(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SaveSepaBankAccountRequestPayloadToJSON)(requestParameters.saveSepaBankAccountRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SaveSepaBankAccountResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * saves the given bank account to the customers profile and genarates a sepa mandate to be accepted by the customer
     */
    CustomerApi.prototype.saveSepaBankAccount = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.saveSepaBankAccountRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForSubscribeToNewsletters = function (requestParameters) {
        if (requestParameters.place === null || requestParameters.place === undefined) {
            throw new runtime.RequiredError('place', 'Required parameter requestParameters.place was null or undefined when calling subscribeToNewsletters.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/permissions/newsletter/{place}".replace("{".concat("place", "}"), encodeURIComponent(String(requestParameters.place)))
        };
    };
    CustomerApi.prototype.getUrlForSubscribeToNewslettersByPUT = function (requestParameters) {
        var _a = this.getInternalCallInfoForSubscribeToNewsletters(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * subscribe to newsletter(s) on order confirmation page
     */
    CustomerApi.prototype.subscribeToNewslettersRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForSubscribeToNewsletters(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * subscribe to newsletter(s) on order confirmation page
     */
    CustomerApi.prototype.subscribeToNewsletters = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscribeToNewslettersRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForTriggerEmailVerification = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/verification"
        };
    };
    CustomerApi.prototype.getUrlForTriggerEmailVerificationByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForTriggerEmailVerification(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     */
    CustomerApi.prototype.triggerEmailVerificationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForTriggerEmailVerification(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CustomerDataWithStatusFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    CustomerApi.prototype.triggerEmailVerification = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.triggerEmailVerificationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForUpdatePermissions = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/permissions"
        };
    };
    CustomerApi.prototype.getUrlForUpdatePermissionsByPUT = function (requestParameters) {
        var _a = this.getInternalCallInfoForUpdatePermissions(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * update the customer\'s permissions settings
     */
    CustomerApi.prototype.updatePermissionsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForUpdatePermissions(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PermissionsToJSON)(requestParameters.permissions),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultWithTokensFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * update the customer\'s permissions settings
     */
    CustomerApi.prototype.updatePermissions = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePermissionsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerApi.prototype.getInternalCallInfoForUpdatePhoneNumber = function (requestParameters) {
        if (requestParameters.index === null || requestParameters.index === undefined) {
            throw new runtime.RequiredError('index', 'Required parameter requestParameters.index was null or undefined when calling updatePhoneNumber.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/customer/phonebook/{index}".replace("{".concat("index", "}"), encodeURIComponent(String(requestParameters.index)))
        };
    };
    CustomerApi.prototype.getUrlForUpdatePhoneNumberByPUT = function (requestParameters) {
        var _a = this.getInternalCallInfoForUpdatePhoneNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * updates a phone number for the customer
     */
    CustomerApi.prototype.updatePhoneNumberRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForUpdatePhoneNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.xEcFp !== undefined && requestParameters.xEcFp !== null) {
                            headerParameters['x-ec-fp'] = String(requestParameters.xEcFp);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SavePhoneNumberRequestToJSON)(requestParameters.savePhoneNumberRequest),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChangeCustomerResultWithPhoneBookFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * updates a phone number for the customer
     */
    CustomerApi.prototype.updatePhoneNumber = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePhoneNumberRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CustomerApi;
}(runtime.BaseAPI));
exports.CustomerApi = CustomerApi;
/**
    * @export
    * @enum {string}
    */
var SubscribeToNewslettersPlaceEnum;
(function (SubscribeToNewslettersPlaceEnum) {
    SubscribeToNewslettersPlaceEnum["OrderConfirmation"] = "orderConfirmation";
})(SubscribeToNewslettersPlaceEnum = exports.SubscribeToNewslettersPlaceEnum || (exports.SubscribeToNewslettersPlaceEnum = {}));
//# sourceMappingURL=CustomerApi.js.map